import { Component, OnInit, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {Pipe} from '@angular/core';
import {IOption} from 'ng-select';
declare  const $;
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
import * as moment from 'moment/moment';
import { flattenStyles } from '@angular/platform-browser/src/dom/dom_renderer';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AlertComponent } from './../alert/alert.component';
import { Popup } from 'ng2-opd-popup';

@Component({
  selector: 'app-service-type',
  templateUrl: './service-type.component.html',
  styleUrls: ['./service-type.component.scss']
})

export class ServiceTypeComponent implements OnInit {
	ToolTip="Delete is not allowed since it is used in contract registration page";
	labourcostDetailsArray=[];
	loading:boolean=true;
	ListserviceTypeDetails:any[] = [];
	btnName:any='Submit';
	EditObjectId:any;
	msgtext:string;
	startingCount:number = 0;
	endingCount:number = 0;
	p: number = 1;
	isValid:boolean=true;
	servicetype:any;
	servicetype_err:boolean=false;
	deleteId:any;
	@ViewChild('add') add: Popup;
 	@ViewChild('update') update: Popup;
	@ViewChild('Askdelete') Askdelete: Popup;
	@ViewChild('delete') delete: Popup;
	@ViewChild('duplicate') duplicate: Popup;
	orgId:number;
	userId:number;
	servicehours_err:boolean=false;
	servicehours:any;
	duplicateMessage:string = 'This Service Type Already Exists';
	isServiceTypeListLoaded:boolean = false;
	isDeleteAvailabilityLoaded:boolean = false;
	constructor(private dialogService:DialogService,private http: Http,private toastyService:ToastyService,private toastyConfig: ToastyConfig,private router:Router,private route : ActivatedRoute) { }

	ngOnInit() {
		this.loading=true;
		this.isServiceTypeListLoaded = false;
		this.isDeleteAvailabilityLoaded = false;
		if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
	    	window.location.href = 'https://still.alshirawi.com/highmessaging/';
	    } else {
	      this.orgId=this.route.params['value'].orgId;
	      this.userId=this.route.params['value'].userId;
	      console.log('OrgId '+ this.orgId);
	      console.log('UserId '+ this.userId);
	    }
		this.getAllServiceDetails();
	}

	getlabourcostdetails(){
		let makeobj={
			'orgId':this.orgId
		}
		return this.http.post('/api/getLabourCostdetails',makeobj).subscribe(
			res=>{
				let response=res.json();
				console.log(response);
				if(response.length>0){
					this.labourcostDetailsArray=response;
					this.CheckTooltip();
				} else {
					this.loading=false;
				}
				
			}
		)
	}

	showAlertForAddingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"ADD SERVICE TYPE",message:"The Data added successfully"});
	}
	
	showAlertForUpdatingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"UPDATE SERVICE TYPE",message:"The Data updated successfully"});
	}
	showAlertForDeletingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"DELETE SERVICE TYPE",message:"The Data deleted successfully"});
	}

	showDuplicatePopup(message) {
		this.duplicateMessage = message;
		this.duplicate.options = {
	        showButtons: false,
	        color: "#4180ab",
	        header: "Service Type"
	    };
	    this.duplicate.show(this.duplicate.options);
	}

	addOk() {
		this.add.hide();
	}

	updateOk() {
		this.update.hide();
	}

	deleteOk() {
		this.delete.hide();
	}

	duplicateOk() {
		this.duplicate.hide();
	}

	updateLoadingState() {
		this.loading = !(this.isServiceTypeListLoaded && this.isDeleteAvailabilityLoaded);
	}

	getCount(){
	 if(this.p < Math.ceil(this.ListserviceTypeDetails.length/10)){
	   this.startingCount = (this.p-1)*10;
	   if(this.startingCount == 0){
	     this.startingCount = 1;
	   }
	   this.endingCount = this.p*10;
	 } else if(this.p == Math.ceil(this.ListserviceTypeDetails.length/10)){
	   let count = this.ListserviceTypeDetails.length%10;
	   this.startingCount = (this.p-1)*10;
	   this.endingCount = this.startingCount + count;
	   if(this.startingCount == 0){
	     this.startingCount = 1;
	     this.endingCount = count;
	   }
	 }
	}

	getAllServiceDetails () {
		this.loading=true;
		this.isServiceTypeListLoaded = false;
		this.isDeleteAvailabilityLoaded = false;
		let serviceTypeObj = {
			'orgId':this.orgId
		}
	    return this.http.post('/api/getServiceTypedetails', serviceTypeObj).subscribe(
	      res => {
			     
	        let ServiceResponse =res.json();
	        this.ListserviceTypeDetails = res.json();
		   if(ServiceResponse.length>0){
				this.getCount();
				this.isServiceTypeListLoaded = true;
				this.loadDeleteAvailability();
		   }else{
			   this.isServiceTypeListLoaded = true;
			   this.isDeleteAvailabilityLoaded = true;
			   this.updateLoadingState();
		   }

		  
	      },(err) =>{
			this.isServiceTypeListLoaded = true;
			this.isDeleteAvailabilityLoaded = true;
			this.updateLoadingState();
	        if(err.status != 200){
	          this.msgtext = "Unable to load the Value";
	          this.getWarningFunction(this.msgtext);
	        }
	    })
    }

	loadDeleteAvailability() {
		let serviceTypeIds = [];

		for(let i=0;i<this.ListserviceTypeDetails.length;i++) {
			this.ListserviceTypeDetails[i].status = false;
			this.ListserviceTypeDetails[i].deleteBlockedReason = '';
			serviceTypeIds.push(this.ListserviceTypeDetails[i]._id);
		}

		return this.http.post('/api/getServiceTypeDeleteAvailability', {
			'ids':serviceTypeIds,
			'orgId':this.orgId
		}).subscribe(
			res => {
				let availabilityResponse = res.json().availability || {};

				for(let i=0;i<this.ListserviceTypeDetails.length;i++) {
					if(availabilityResponse[String(this.ListserviceTypeDetails[i]._id)] && availabilityResponse[String(this.ListserviceTypeDetails[i]._id)].canDelete === false) {
						this.ListserviceTypeDetails[i].status = true;
						this.ListserviceTypeDetails[i].deleteBlockedReason = availabilityResponse[String(this.ListserviceTypeDetails[i]._id)].reason || this.ToolTip;
					}
				}

				this.isDeleteAvailabilityLoaded = true;
				this.updateLoadingState();
			},(err) => {
				this.isDeleteAvailabilityLoaded = true;
				this.updateLoadingState();
				if(err.status != 200){
					this.msgtext = "Unable to validate delete availability";
					this.getWarningFunction(this.msgtext);
				}
			}
		)
	}

    getserviceTypedetails() {
    	if(this.servicetype == null || this.servicetype == "" || this.servicetype == undefined) {
    		this.servicetype_err=true;
    		this.isValid=false;
    	} else {
    		this.servicetype_err=false;
    		this.isValid=true;
    	}
    }

    // getservicehoursdetails() {
    // 	if(this.servicehours == null || this.servicehours == "" || this.servicehours == undefined) {
    // 		this.servicehours_err=true;
    // 		this.isValid=false;
    // 	} else {
    // 		this.servicehours_err=false;
    // 		this.isValid=true;
    // 	}
    // }

    addserviceType() {
		// this.spinner.show();
		this.loading=true;
    	if(this.servicetype == null || this.servicetype == "" || this.servicetype == undefined) {
    		this.loading=false;
    		document.body.scrollTop = 0;
        	document.documentElement.scrollTop = 0;
    		this.servicetype_err=true;
    		this.isValid=false;
		} else {
			console.log(this.EditObjectId);
    		if(this.EditObjectId == null || this.EditObjectId == "" || this.EditObjectId == undefined) {
    			let reqserviceTypeObj = {
			        'serviceType':this.servicetype.toLowerCase(),
			      //  'serviceHours':this.servicehours,
			        'orgId':this.orgId,
			        'created_By':this.userId,
			        'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
			    }
			    return this.http.post('/api/addserviceTypeValue', reqserviceTypeObj).subscribe(
			    res => {
			        let serviceTypeResponse = res.json();
			        if(serviceTypeResponse.message == 'This Service Type Already Exists') {
					 this.loading=false;
			          this.showDuplicatePopup('This Service Type Already Exists');
			        } else {
			          this.MYSQLEntryAddServiceType();
			        }
			    },(err) =>{
				   // this.spinner.hide();
				   this.loading=false;
			        if(err.status != 200){
			          this.msgtext = "Unable to load the Value";
			          this.getWarningFunction(this.msgtext);
			        }
			    })
    		} else {
    			let reqserviceTypeObj = {
			        'serviceType':this.servicetype.toLowerCase(),
			     //   'serviceHours':this.servicehours,
			        'EditObjectId':this.EditObjectId,
			        'orgId':this.orgId,
			        'updated_By':this.userId,
			        'updated_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
				}
				console.log("adjaj");
			    return this.http.post('/api/UpdateServiceTypeDetails', reqserviceTypeObj).subscribe(
			    res => {
			        let serviceTypeResponse = res.json();
			        if(serviceTypeResponse.message == 'This Service Type Already Exists') {
					 this.loading=false
			          this.showDuplicatePopup('This Service Type Already Exists');
			        } else {
			          this.MYSQLEntryUpdateServiceType();
			        }
			    },(err) =>{
					//this.spinner.hide();
					this.loading=false
			        if(err.status != 200){
			          this.msgtext = "Unable to load the Value";
			          this.getWarningFunction(this.msgtext);
			        }
			    })
    		}
    	}
    }

    MYSQLEntryAddServiceType() {
	    let reqserviceTypeObj = {
	        'serviceType':this.servicetype.toLowerCase(),
	      //  'serviceHours':this.servicehours,
	        'orgId':this.orgId,
	        'created_By':this.userId,
	        'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
	    }
	    return this.http.post('/api/MYSQLaddserviceTypeValue', reqserviceTypeObj).subscribe(
	    res => {
			//this.spinner.hide();
			this.loading=false;
	        this.showAlertForAddingdata();
	        //alert('added successfully');
	      this.Empty();
	      this.getAllServiceDetails();
	    },(err)=>{
		  //this.spinner.hide();
		  this.loading=false;
	      this.msgtext = "Unable to add the Value Into Mysql";
	      this.getWarningFunction(this.msgtext);
	    })
	}

	MYSQLEntryUpdateServiceType() {
	    let reqserviceTypeObj = {
	        'serviceType':this.servicetype.toLowerCase(),
	       // 'serviceHours':this.servicehours,
	        'EditObjectId':this.EditObjectId,
	        'orgId':this.orgId,
	        'updated_By':this.userId,
	        'updated_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
	    }
	    return this.http.post('/api/MYSQLUpdateserviceTypeDetails', reqserviceTypeObj).subscribe(
	    res => {
		   // this.spinner.hide();
		   this.loading=false;
	        this.showAlertForUpdatingdata();
	      //alert('Update successfully');
	      this.Empty();
	      this.getAllServiceDetails();
	    },(err)=>{
		  //this.spinner.hide();
		  this.loading=false
	      this.msgtext = "Unable to add the Value Into Mysql";
	      this.getWarningFunction(this.msgtext);
	    })
	}

	// Editing(index, edit) {
	// 	   
	// 	document.body.scrollTop = 0;
 //        document.documentElement.scrollTop = 0;
	// 	this.EditObjectId = edit;
 //        this.btnName='Update';
	// 	this.servicetype = this.ListserviceTypeDetails[index].servicetype;
	// 	//this.servicehours = this.ListserviceTypeDetails[index].serviceHours;
	// }

	Editing(index, edit) {
	     
	    document.body.scrollTop = 0;
	    document.documentElement.scrollTop = 0;
	    this.EditObjectId = edit;
	    this.btnName='Update';
	  
	    for(let i=0;i<this.ListserviceTypeDetails.length;i++){
		    if(this.ListserviceTypeDetails[i]._id==edit){
		    	this.servicetype = this.ListserviceTypeDetails[i].servicetype;
		    }
	    }
    }

	Empty(){
		this.servicetype="";
	    this.EditObjectId="";
		this.servicetype_err=false;
	    this.isValid=true;
		this.btnName='Submit';
    }

	reset() {
		this.Empty();
	}

	Delete(index, deleteId, serviceTypeRow?) {
		if(serviceTypeRow && serviceTypeRow.status === true) {
			this.msgtext = serviceTypeRow.deleteBlockedReason || this.ToolTip;
			this.getWarningFunction(this.msgtext);
			return false;
		}
		this.Empty();
		this.deleteId = deleteId;
		this.Askdelete.options = {
	        showButtons: false, // You can hide this in case you want to use custom 
	        color: "#4180ab",
	        header: "Delete Service Type"
	    };
	    this.Askdelete.show(this.Askdelete.options);
	}

	No() {
		this.Askdelete.hide();
	}

	Yes() {
		this.Askdelete.hide();
		//this.spinner.show();
		this.loading=true;
		let reqMakeObj = {
	        'deleteId':this.deleteId,
	        'orgId':this.orgId
	    }
	    return this.http.post('/api/deleteServiceTypeDetails', reqMakeObj).subscribe(
	      res => {
	        let makeResponse = res.json();
				if(makeResponse && makeResponse.canDelete === false) {
					this.loading=false;
					this.msgtext = makeResponse.reason || this.ToolTip;
					this.getWarningFunction(this.msgtext);
					this.getAllServiceDetails();
					return false;
				}
	        this.MYSQLDeletemake();
	    },(err)=>{
	        // this.spinner.hide();
				this.loading=false;
	        this.msgtext = "Unable to Add the Value in mysql";
	        this.getWarningFunction(this.msgtext);
	    })
	}

	MYSQLDeletemake() {
		let reqMakeObj = {
	        'deleteId':this.deleteId
	    }
		return this.http.post('/api/MYSQLDeleteserviceTypeDetails', reqMakeObj).subscribe(
	      res => {
		   // this.spinner.hide();
		   this.loading=false;
	        let makeResponse = res.json();
	        // this.delete.options = {
		    //     showButtons: false, // You can hide this in case you want to use custom 
		    //     color: "#4180ab",
		    //     header: "Make Deleted"
		    // };
			// this.delete.show(this.delete.options);
			this.showAlertForDeletingdata();
		    this.deleteId="";
	        this.getAllServiceDetails();
	        this.Empty();
	    },(err)=>{
		   // this.spinner.hide();
		   this.loading=false;
	        this.msgtext = "Unable to Add the Value in mysql";
	        this.getWarningFunction(this.msgtext);
	    })
	}

	deletesuccessOk() {
		this.delete.hide();
	}

	
CheckTooltip(){
	   
	if(this.ListserviceTypeDetails.length==0||this.ListserviceTypeDetails.length==undefined){
		this.getAllServiceDetails();
	}else if(this.labourcostDetailsArray.length==0||this.labourcostDetailsArray.length==undefined){
		this.getlabourcostdetails();
	}else{
		for(let z=0;z<this.ListserviceTypeDetails.length;z++){
			for(let i=0;i<this.labourcostDetailsArray.length;i++){
				if(this.labourcostDetailsArray[i].serviceType==this.ListserviceTypeDetails[z]._id){
					this.ListserviceTypeDetails[z].status = true;
			}	
		}
	}
	this.loading=false;
	}



}


// 	deleteService(index,objectID){
// 		   
// 		for(let z=0;z<this.ListserviceTypeDetails.length;z++){
// 			if(this.ListserviceTypeDetails[z]._id==objectID){

// 	for(let i=0;i<this.labourcostDetailsArray.length;i++){
// if(z<this.labourcostDetailsArray.length){
// 	if(this.labourcostDetailsArray[i].serviceType==objectID){
// 		this.ListserviceTypeDetails[z].status = true;
// 		}
// }	
// 	  	}
// 	}
// }
// 	for(let z=0;z<this.ListserviceTypeDetails.length;z++){
// 		   
// 		if(	this.ListserviceTypeDetails[z].status ==true&&this.ListserviceTypeDetails[z]._id==objectID){
// 			alert("this Service type cannot be deleted as it is used in Labour Cost");
// 		}else if(this.ListserviceTypeDetails[z].status ==false&&this.ListserviceTypeDetails[z]._id==objectID){
// 			this.Delete(index,objectID);
// 		}
// 	}
// 	}
    getWarningFunction(errMsg) {
    var toastOptions:ToastOptions = {
        title: "Check List Master",
        msg: errMsg,
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap',
        onAdd: (toast:ToastData) => {
        },
        onRemove: function(toast:ToastData) {
        }
      };
      this.toastyService.warning(toastOptions);
  }//getWarningFunction end here


  getSuccessFunction(successMsg){
    var toastOptions:ToastOptions = {
      title: "Check List Master",
      msg: successMsg,
      showClose: true,
      timeout: 3000,
      theme: 'bootstrap',
      onAdd: (toast:ToastData) => {
      },
      onRemove: function(toast:ToastData) {
      }
    };
    this.toastyService.success(toastOptions);
  }//getSuccessFunction end here
}


// WEBPACK FOOTER //
// ./client/app/service-type/service-type.component.ts